export default "__VITE_ASSET__CQdPo6ca__"